<template>
  <div class="contributions">
    <div class="col col1">
      <div class="row row1">
        <img class="logoname" alt src="../assets/header_logo.svg" />
      </div>
      <div class="row row2">
        <div class="title">Original Version</div>
        <div class="name">Katie McCoy</div>
        <div class="name">Jerry Low</div>
        <div class="name">Amit Jakhu</div>
      </div>
    </div>
    <div class="col col2">
      <div class="row row1"></div>
      <div class="row row2">
        <div class="title">Open Source</div>
        <div class="name">Anna Mackenzie</div>
        <div class="name">David Colburn</div>
        <div class="name">Shanil Patel</div>
        <div class="name">Tim Fernihough</div>
        <div class="name">Dylan Pomeroy</div>
        <div class="name">Jacques Ramphal</div>
      </div>
      
    </div>
    <div class="col col3">
      <div class="row row1"></div>
      <div class="row row2">
        <div class="title">Interested in what we do?</div>
        <div>
          <a href="https://www.orium.com" target="_blank" class="highlight">www.orium.com</a>
        </div>
      </div>
      <div class="row row3">
        <div class="title">Socialize with Us</div>
        <a href="https://blog.orium.com/" target="_blank" class="highlight">Medium</a>
        <a href="https://twitter.com/oriuminc" target="_blank" class="highlight">Twitter</a>
        <a href="https://www.linkedin.com/company/oriuminc/" target="_blank" class="highlight">LinkedIn</a>
        <a href="https://github.com/oriuminc" target="_blank" class="highlight">Github</a>
        <a href="https://www.facebook.com/oriuminc/" target="_blank" class="highlight">Facebook</a>
      </div>
    </div>
    <div class="col col4">
      <div class="imageContainer">
        <img class="image" alt="scrap-bg" src="../assets/scrap.jpg" />
      </div>
    </div>
    <div class="col col5">
      <div class="row row1">
        <div class="title">Interested in <br> what we do?</div>
        <div>
          <a href="https://www.orium.com" target="_blank" class="highlight">www.orium.com</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contributions",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}
.contributions {
  display: flex;
  height: 710px;
  width: 60%;
  margin: 0 auto;
  overflow: hidden;
  background-color: #fef2ef;
  justify-content: space-between;
}

.contributions .imageContainer {
  max-width: 100%;
}

.contributions .image {
  height: 710px;
  width: 384px;
}

.contributions .logo {
  height: 46px;
  width: 46px;
}

.contributions .highlight {
  color: #f25930;
  font-family: "SofiaProRegular";
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 32px;
  margin: 5px 0;
}

.contributions .name {
  width: 247px;
  color: #121221;
  font-family: "SofiaProRegular";
  font-size: 18px;
  letter-spacing: 0;
  line-height: 28px;
}

.contributions .logoname {
  height: 24px;
}

.contributions .col {
  display: flex;
  text-align: left;
  flex-direction: column;
  width: 340px;
}

.contributions .row {
  display: flex;
  flex-direction: column;
  height: 160px;
}

.contributions .col3 {
  width: 375px;
}

.contributions .row2,``
.contributions .row3 {
  height: 109px;
  /* padding: 0 40px; */
}

.contributions .col2 .row2 {
  margin-left: 50px;
}

.contributions .col1 .row2 {
  margin-left: 100px;
}

.contributions .col1 .row1 {
  flex-direction: row;
  align-items: center;
  margin-left: 100px;
}

.contributions .col5 {
  display: none;
}

.contributions .title {
  text-transform: uppercase;
  height: 24px;
  width: 274px;
  color: #9292a8;
  font-family: "SofiaProRegular";
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 24px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

@media only screen and (min-width: 1200px) and (max-width: 1448px) {
  .contributions {
    width: 80%;
    margin: 0 auto;
  }
}

@media only screen and (min-width: 1029px) and (max-width: 1199px) {
  .contributions .logoname {
  height: 24px;
}
  .contributions {
    width: 80%;
    margin: 0 auto;
  }

  .contributions .col {
    width: 32.5%;
  }

  .contributions .col1 .row1,
  .contributions .col1 .row2 {
    margin-left: 50px;
  }

  .contributions .col3 .row {
    padding-left: 20px;
  }

  .contributions .col4 {
    display: none;
  }
}

@media only screen and (min-width: 823px) and (max-width: 1028px) {
  .contributions {
    width: 800px;
    margin: 0 auto;
    flex-wrap: wrap;
    height: 800px;
  }

  .contributions .col3 {
    height: 0;
    margin-left: 40px;
  }

  .contributions .col3 .row3 {
    height: 400px;
  }

  .contributions .col2 .row2 {
    margin-left: 0;
    margin-bottom: 80px;
  }

  .contributions .col3 .row2 {
    margin-top: 60px;
    margin-bottom: 40px;
  }

  .contributions .col1 .row1,
  .contributions .col1 .row2 {
    margin-left: 40px;
  }
}

@media only screen and (min-width: 515px) and (max-width: 823px) {
  .contributions {
    width: 100%;
    flex-wrap: wrap;
  }

  .contributions .col,
  .contributions .col .row {
    width: 250px;
    margin: 0px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .contributions .col3 .row1 {
    height: 0px;
  }

  .contributions .col3 .row2 {
    display: none;
  }

  .contributions .col5 {
    display: block;
  }

  .contributions .col4 {
    display: none;
  }

  br {
    display: none
  }
}

@media only screen and (min-width: 375px) and (max-width: 515px) {
  .contributions {
    width: 100%;
    flex-wrap: wrap;
    margin: 0;
  }

  .contributions .col,
  .contributions .col .row {
    width: 150px;
    margin: 0px;
  }

  .contributions .col {
    margin-left: 15px;
    margin-right: 15px;
  }

  .contributions .col3 .row1 {
    height: 0px;
  }

  .contributions .col3 .row2 {
    display: none;
  }

  .contributions .col5 {
    display: block;
    width: 180px;
    margin-left: 0px;
  }

  .contributions .col2 {
    margin-left: 0px;
    width: 180px;
  }

  .contributions .col2 .row {
    margin-left: 0px;
    width: 200px;
  }

  .contributions .col5 .row1 .title {
    height: 45px;
  }

  .contributions .col5 .row1 .highlight {
    font-size: 18px;
  }

  .contributions .col3 .row3 .highlight {
    font-size: 18px;
    line-height: 24px;
  }

  .contributions .col4 {
    display: none;
  }
}
</style>
